import axios from 'axios';


const api = axios.create({

 // baseURL: 'https://git.kpru.ac.th/FrontEnd_Kprupsf/'
 baseURL: 'https://mua.kpru.ac.th/FrontEnd_Kprupsf/'
// baseURL: 'http://localhost:5000/api/'
});



const URL = axios.create({

  // baseURL: 'https://e-student.kpru.ac.th/refund/api/'
  baseURL: 'https://git.kpru.ac.th/FrontEnd_Conferencekpru/'
 // baseURL: 'http://localhost:3000/adminconference-sd'
 });

const apilogin = axios.create({
//baseURL: 'https://e-student.kpru.ac.th/refund/api/',
//baseURL: 'hhttps://admission.kpru.ac.th/refund/api/',
//baseURL: 'http://localhost:5000/api/',
  headers: {
    'Authorization': 'Bearer ' + window.localStorage.getItem('auth')
  }
});


export { api, apilogin, URL };
